const validationMessages = {
  required: (field) => `${field} is required`,
  password: {
    tooShort: () => "Password must be at least 8 characters long.",
    missingUpper: () => "Password must include at least one uppercase letter.",
    missingLower: () => "Password must include at least one lowercase letter.",
    missingNumber: () => "Password must include at least one number.",
    missingSpecial: () =>
      "Password must include at least one special character (@$!%*?&).",
    combined: () =>
      "Password must be at least 8 characters long and include one uppercase, one lowercase, one number, and one special character.",
  },
  email: "Please enter a valid email address.",
  name: {
    invalidPersonName:
      "Name can contain only letters, spaces, apostrophes (') and hyphens (-).",
    invalidProjectName:
      "Project name can contain any characters except '<' and '>'.",
    trailingChar: "Name cannot end with an apostrophe or hyphen.",
    tooShort: "Name must be at least 2 characters long.",
    tooLong: "Please limit your name up to 30 characters.",
  },
};

export default validationMessages;
